import { Controller } from "@hotwired/stimulus"
import { api } from "../composables/useApi"

// Form-behavior controller for demographics: handles the country -> state
// cascade and shows/hides US-only political affiliation options. Saving is
// owned by the parent profile-edit-mode controller (commit-on-Done).
export default class extends Controller {
  static targets = ["country", "state", "politicalAffiliation"]
  static values = {
    currentCountry: String,
    currentState: String,
  }

  connect() {
    this.countryChanged()
  }

  countryChanged() {
    const country = this.countryTarget.value
    const isUS = country === "US"

    if (this.hasPoliticalAffiliationTarget) {
      this.politicalAffiliationTarget.querySelectorAll("option[data-us-only='true']").forEach((option) => {
        option.hidden = !isUS
        option.disabled = !isUS
      })

      if (!isUS) {
        const selected = this.politicalAffiliationTarget.selectedOptions[0]
        if (selected && selected.dataset.usOnly === "true") {
          this.politicalAffiliationTarget.value = ""
        }
      }
    }

    this.loadSubdivisionsForCountry(country)
  }

  loadSubdivisionsForCountry(countryCode) {
    if (!this.hasStateTarget) return

    this.stateTarget.innerHTML = '<option value="">Loading...</option>'
    this.stateTarget.disabled = true
    this.notifyStateChanged()

    if (!countryCode) {
      this.stateTarget.innerHTML = '<option value="">Select country first</option>'
      this.notifyStateChanged()
      return
    }

    api.get(`/api/demographics/states/${countryCode}`)
      .then(subdivisions => {
        this.stateTarget.innerHTML = ""
        if (subdivisions.length === 0) {
          this.stateTarget.innerHTML = '<option value="">N/A for this country</option>'
          this.stateTarget.disabled = true
        } else {
          const defaultOption = document.createElement("option")
          defaultOption.value = ""
          defaultOption.textContent = "Select region"
          this.stateTarget.appendChild(defaultOption)

          subdivisions.forEach(subdivision => {
            const option = document.createElement("option")
            option.value = subdivision.code
            option.textContent = subdivision.name
            if (subdivision.code === this.currentStateValue) option.selected = true
            this.stateTarget.appendChild(option)
          })
          this.stateTarget.disabled = false
        }
        this.notifyStateChanged()
      })
      .catch(error => {
        console.error("Failed to load subdivisions:", error)
        this.stateTarget.innerHTML = '<option value="">Error loading regions</option>'
        this.stateTarget.disabled = true
        this.notifyStateChanged()
      })
  }

  notifyStateChanged() {
    this.stateTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
